import axios from 'axios';

import { API_URL } from 'constants/api';

const axiosDefaults = () => {
  axios.defaults.baseURL = API_URL;
};

export default axiosDefaults;
